<template>
  <div>
    <div class="flex flex-wrap">
      <div
        class="xl:w-1/4 md:w-1/2 p-2 w-full h-full"
        v-for="(item, index) in lessons"
        :key="index"
      >
        <div class="card_container shadow_box">
          <img
          v-if="item.course.picture!=null"
            style="height: 126px;
              object-fit: contain;
              background-color: #b1faff;
            "
            class="w-full"
            :src="item.course.picture"
            alt="Illustration"
          />
          <img
            v-else
            style="
              height: 126px;
              object-fit: contain;
              background-color: #b1faff;
            "
            class="w-full"
            src="@/assets/images/Illustration.png"
            alt="Illustration"
          />
          <div class="p-4">
            <div class="meetup-header">
              <div class="meetup_inner_holder">
                <div class="meetup-day">
                  <h6 class="mb-0">{{ item.schedule_date | moment("ddd") }}</h6>
                  <h3 class="mb-0">{{ item.schedule_date | moment("D") }}</h3>
                </div>
                <div class="name_holder my-auto">
                  <h4 class="card-title">{{ item.course.name }}</h4>
                  <p>{{ getCourseTypeName(item.course.course_class_type) }}</p>
                </div>
              </div>
            </div>
            <div class="inform-meetup-holder">
              <div class="badge-avatar">
                <span class="material-icons">date_range</span>
              </div>
              <div>
                <h6>
                  {{ item.schedule_from_time.slice(0, -3) }} -
                  {{ item.schedule_to_time.slice(0, -3) }}
                </h6>
                <small>{{
                  timeDiff(item.schedule_from_time, item.schedule_to_time)
                }}</small>
              </div>
            </div>
            <div class="inline-flex items-center">
              <!-- <div v-for="(client, index) in item.client" :key="index">
                <vs-tooltip color="primary" :text="client.first_name+' '+client.last_name">
                <img v-if="client.picture"
                src="https://scoolio-files.s3.ap-south-1.amazonaws.com/20211129063744097501/Default/ZMeDui6nG1Ez3c92.jpg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <span v-else class="material-icons" style="font-size: 40px"
                >account_circle</span
              >
            </vs-tooltip>
              </div> -->
             
              <!-- <p class="pl-2">Feriha Dawn</p> -->
            </div>
          </div>
        </div>
      </div>

      <div class="xl:w-1/4 md:w-1/2 p-2 w-full h-full">
        <div
          style="max-height: 336px; overflow: auto"
          class="card_container shadow_box vertical_scrollbar p-3"
        >
          <div class="lesson_info_holder green_container p-2">
            <div class="info_holder">
              <div class="inline-flex flex-wrap items-center icon_data">
                <span class="material-icons-outlined">schedule</span>
                <h4 class="heading pl-2">{{todayActivity.first_session_start_time?todayActivity.first_session_start_time.slice(0,-3):''}}</h4>
              </div>
              <h6 class="pt-1 pb-2">First Lesson Start</h6>
              <div class="inline-flex flex-wrap items-center">
                <span class="material-icons-outlined event">event</span>
                <p class="pl-2">{{today | dateFormatLocalization}}</p>
              </div>
            </div>
          </div>

          <div class="lesson_info_holder yellow_container p-2">
            <div class="info_holder">
              <div class="inline-flex flex-wrap items-center icon_data">
                <span class="material-icons-outlined">schedule</span>
                <h4 class="heading pl-2">{{todayActivity.next_break_starts_at?todayActivity.next_break_starts_at.slice(0,-3):''}}</h4>
              </div>
              <h6 class="pt-1 pb-2">Next break in</h6>
              <div class="inline-flex flex-wrap items-center">
                <span class="material-icons-outlined event">event</span>
                <p class="pl-2">{{today | dateFormatLocalization}}</p>
              </div>
            </div>
          </div>

          <div class="lesson_info_holder red_container p-2">
            <div class="info_holder">
              <div class="inline-flex flex-wrap items-center icon_data">
                <span class="material-icons-outlined">schedule</span>
                <h4 class="heading pl-2">{{todayActivity.last_session_end_time?todayActivity.last_session_end_time.slice(0,-3):''}}</h4>
              </div>
              <h6 class="pt-1 pb-2">Last Lesson Ends</h6>
              <div class="inline-flex flex-wrap items-center">
                <span class="material-icons-outlined event">event</span>
                <p class="pl-2">{{today | dateFormatLocalization}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchLessons, fetchLessonTime } from '@/api/dashboard.js'
import moment from 'moment'

export default {
  data () {
    return {
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      customer_id: localStorage.getItem('customer_id'),
      lessons: [],
      dateRange: null,
      meta: {
        current_page: 1,
        has_next: false,
        limit: 3,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      today:moment(new Date()).format('L'),
      todayActivity :{
        first_session_start_time:null,
        last_session_end_time:null,
        next_break_starts_at:null
      }
    }
  },
  mounted () {
    this.fetchLessons(1)
    this.fetchLessonTime()
  },
  methods: {
    async fetchLessonTime () {
      const {data} = await fetchLessonTime(this.customer_id)
      this.todayActivity = data.data

    },
    getCourseTypeName (type) {
      const getType = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (getType.length) return getType[0].name
      return ''
    },
    timeDiff (from_time, to_time) {
      //create date format
      const timeStart = new Date(`01/01/2007 ${from_time}`).getTime()
      const timeEnd = new Date(`01/01/2007 ${to_time}`).getTime()

      let hourDiff = timeEnd - timeStart

      hourDiff = hourDiff / 1000
      const hourDifference = Math.floor(hourDiff / 3600)
      hourDiff -= hourDifference * 3600
      const minuteDifference = Math.floor(hourDiff / 60)
      hourDiff -= minuteDifference * 60
      return hourDifference > 0
        ? `${hourDifference}:${minuteDifference}hr`
        : `${minuteDifference}min`
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight &&
        this.meta.has_next
      ) {
        this.loadMoreLessons()
      }
    },
    async loadMoreLessons () {
      const payload = {
        dateRange: this.dateRange === null ? 1 : this.dateRange
      }
      this.meta.current_page = this.meta.current_page + 1
      const { data } = await fetchLessons(this.customer_id, payload, this.meta)
      this.lessons.push(...data.data.schedules)
      this.meta = data.data.meta
    },
    async fetchLessons () {
      //1= today, 2 = week, 3 = month, 4 year
      const payload = {
        dateRange: this.dateRange === null ? 1 : this.dateRange === 1 ? 2 : 1,
        limit: 3
      }
      this.dateRange = payload.dateRange
      const { data } = await fetchLessons(this.customer_id, payload, this.meta)
      this.lessons = data.data.schedules
      this.meta = data.data.meta
    },
    getTeacher (teachers) {
      const tutors = teachers.map((teacher) => {
        return `${teacher.first_name} ${teacher.last_name}`
      })
      return tutors.join(', ')
    }
  }
}
</script>